import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const useBanner = () => {
  const { api, userID } = useContext(GlobalContext);


  const [status, setStatus] = useState(null);

  const postRequest = async (
  endpoint,
  payload = {}
) => {
  const response = await api.post(
    endpoint,
    payload
  );

  return response?.data;
};

  const fetchStatus = async () => {
    try {
      const data = await postRequest(
  "/Inventory/v2.0/getBannerStatus",
  {}
);

if (data?.responseCode === "00") {
  setStatus(data?.response);
} else {
        toast.error("Failed to fetch status");
      }
    } catch (err) {
      toast.error("Status API error");
    }
  };

  //  Fetch banner using dynamic userid + status
 const fetchBanner = async (setFetchedBanner) => {
  try {
    if (!userID) return;

    const res = await api.post(
      "/Inventory/v2.0/getCardLayoutGrocery",
      {
        userid: userID,
        status: "A", 
      },
    );

    if (res.data?.responseCode === "00") {
      setFetchedBanner(res.data.response || []);
    } else {
      toast.error(res.data?.responseMessage || "Failed");
    }
  } catch (err) {
    console.log(err);
    toast.error("Server error");
  }
};

const updateBannerStatus = async (item, status, callback) => {
  try {
    const res = await api.post(
      "/Inventory/v2.0/updateCardLayoutGroceryStatus",
      {
        userid: Number(item.fk_userid),
        cardid: Number(item.id),
        status: status,
      },
    );

    console.log("Update banner payload:", {
      userid: Number(item.fk_userid),
      cardid: Number(item.id),
      status,
    });

    console.log("Update banner response:", res.data);

    if (res.data?.responseCode === "00") {
      toast.success("Status updated");
      callback && callback();
    } else {
      toast.error(res.data?.responseMessage || "Failed");
    }

    return res.data;
  } catch (err) {
    console.log(err);
    toast.error("Server error");
    throw err;
  }
};

  const createBanner = async (formData, navigate) => {
  try {
    const res = await api.post(
     "/Inventory/v2.0/insertCardLayoutGrocery",
      {
        userid: userID, 
        cardCount: formData.cardCount,
        html: formData.html,
        title: formData.title,
        status: formData.status,
      },
    );

    if (res.data?.responseCode === "00") {
      toast.success(res.data?.responseMessage || "Banner created");
      navigate("/Inventory/Banner/banner-library");
    } else {
      toast.error(res.data?.responseMessage || "Failed");
    }
  } catch (err) {
    toast.error("Server error");
  }
};

const deleteBanner = async (id, callback) => {
  try {
    if (!id) {
      toast.error("Banner ID missing");
      return;
    }

    const res = await api.post(
      "/Inventory/deleteGroceryLayoutV2",
      {
        id: String(id),
      },
    );

    if (res.data?.responseCode === "00") {
      toast.success(res.data?.responseMessage || "Banner deleted");
      callback && callback();
    } else {
      toast.error(res.data?.responseMessage || "Delete failed");
    }
  } catch (err) {
    console.log("Delete banner error:", err);
    toast.error("Server error");
  }
};

  return {
    fetchBanner,
    updateBannerStatus,
    fetchStatus,
    status,
    createBanner,
    deleteBanner,
  };
};

export default useBanner;